// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./infinity.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SubscriptionFeatureList__feature {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  position: relative;
  margin-bottom: 16px;
}
.SubscriptionFeatureList__feature:last-child {
  margin-bottom: 0;
}
.SubscriptionFeatureList__feature .zervant-icon {
  position: relative;
  margin-right: 17px;
  top: 2px;
}
.SubscriptionFeatureList__featureType__invoicing__title, .SubscriptionFeatureList__featureType__accounting__title, .SubscriptionFeatureList__featureType__admin__title {
  color: #002E33;
  font-size: 14px;
  font-weight: bold;
  margin: 30px 0;
}
.SubscriptionFeatureList__featureType__invoicing__text, .SubscriptionFeatureList__featureType__accounting__text, .SubscriptionFeatureList__featureType__admin__text {
  font-size: 11px;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: normal;
  text-align: left;
  color: #002E33;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  gap: 5px;
}
.SubscriptionFeatureList__featureType__invoicing__text__infinity, .SubscriptionFeatureList__featureType__accounting__text__infinity, .SubscriptionFeatureList__featureType__admin__text__infinity {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center;
  background-size: 12px;
  width: 12px;
  height: 15px;
}
.SubscriptionFeatureList__featureType__invoicing__title {
  margin-top: -5px;
}
.SubscriptionFeatureList__amount {
  color: #002E33;
  font-weight: bold;
  -ms-flex-negative: 0;
      flex-shrink: 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  margin-left: 27px;
  margin-top: -12px;
}
.SubscriptionFeatureList__amount.amount_invoice {
  font-size: 0.9rem;
  margin-bottom: 0.65rem;
  padding-top: 0.3rem;
}
.SubscriptionFeatureList__amount__asterisk {
  padding-left: 5px;
  font-weight: normal;
  color: #002E33;
}
.SubscriptionFeatureList__blackMinus {
  height: 2px;
  width: 11px;
  background-color: #002E33;
  margin-top: 8px;
}
.SubscriptionFeatureList__text {
  font-size: 11px;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: normal;
  text-align: left;
  color: #002E33;
}
.SubscriptionFeatureList__text_invoices {
  font-size: 11px;
  font-weight: 500;
  margin-left: 27px;
  line-height: 16px;
  letter-spacing: normal;
  text-align: left;
  color: #002E33;
}
.SubscriptionFeatureList__text_invoices_starter_num {
  color: #002E33;
  font-weight: bold;
  -ms-flex-negative: 0;
      flex-shrink: 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  margin-left: 27px;
  margin-top: -16px;
}
.SubscriptionFeatureList__text_invoices_pro_num {
  color: #002E33;
  font-weight: bold;
  -ms-flex-negative: 0;
      flex-shrink: 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  margin-left: 27px;
  margin-top: -16px;
}
.SubscriptionFeatureList__text_invoices_pro {
  color: #002E33;
  font-weight: bold;
  -ms-flex-negative: 0;
      flex-shrink: 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  margin-left: 28px;
  margin-top: -16px;
}
.SubscriptionFeatureList__text_invoices_pro_dropdown {
  color: #002E33;
  font-weight: bold;
  -ms-flex-negative: 0;
      flex-shrink: 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  margin-left: 10px;
  margin-top: 9px;
}
.SubscriptionFeatureList__text_invoices_starter {
  color: #002E33;
  font-weight: bold;
  -ms-flex-negative: 0;
      flex-shrink: 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  margin-left: 28px;
  margin-top: -16px;
}
.SubscriptionFeatureList__text_invoices_estimates {
  color: #002E33;
  font-weight: bold;
  -ms-flex-negative: 0;
      flex-shrink: 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  margin-left: 27px;
  margin-top: -12px;
}
.SubscriptionFeatureList__text_premium_invoice {
  font-size: 11px;
  font-weight: 500;
  margin-left: 27px;
  line-height: 16px;
  letter-spacing: normal;
  text-align: left;
  color: #002E33;
}
.SubscriptionFeatureList__text_premium_customers {
  font-size: 11px;
  font-weight: 500;
  margin-left: 27px;
  line-height: 16px;
  letter-spacing: normal;
  text-align: left;
  color: #002E33;
}
.SubscriptionFeatureList__invoice-quota-multiple-plan_wrapper {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
      -ms-flex-direction: row;
          flex-direction: row;
  margin: -0.6rem 0 0.5rem;
}
.SubscriptionFeatureList__invoice-quota-multiple-plan {
  display: inline-block;
  font-size: 1.2rem;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  height: 32px;
  padding: 0 9px;
  background-color: #F5F6F9;
  border: 1px solid #E8E9F0;
  line-height: 32px;
  font-size: 0.9rem;
  font-weight: bold;
}
.SubscriptionFeatureList__invoice-quota-multiple-plan__asterisk {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  color: #002E33;
  padding-left: 10px;
  font-size: 0.9rem;
}
.SubscriptionFeatureList__checkmark {
  position: relative;
  width: 11px;
  height: 11px;
  margin-right: 19px;
  -ms-flex-negative: 0;
      flex-shrink: 0;
  top: 2px;
}
.SubscriptionFeatureList__line {
  margin-top: 16px;
  height: 1px;
  background-color: #f4f5f8;
  margin-bottom: 16px;
}
.SubscriptionFeatureList__spacing {
  margin-bottom: 16px;
}
.SubscriptionFeatureList--highlighted-items {
  padding-bottom: 15px;
  border-bottom: 1px solid #F5F6F9;
  margin-bottom: 15px;
}
.SubscriptionFeatureList--highlighted-items .SubscriptionFeatureList__feature {
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
}`, "",{"version":3,"sources":["webpack://./src/client/components/Subscription/PremiumPlans/FeatureList/FeatureList.scss","webpack://./src/client/Global/Colors.scss"],"names":[],"mappings":"AAEE;EACE,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,kBAAA;EACA,mBAAA;AADJ;AAGI;EACE,gBAAA;AADN;AAGI;EACE,kBAAA;EACA,kBAAA;EACA,QAAA;AADN;AAQI;EACE,cCnBS;EDoBT,eAAA;EACA,iBAAA;EACA,cAAA;AANN;AAQI;EACE,eAAA;EACA,gBAAA;EAEA,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,cC/BS;EDgCT,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,QAAA;AAPN;AASM;EACE,oEAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;AAPR;AAaI;EACE,gBAAA;AAXN;AAeE;EACE,cCnDW;EDoDX,iBAAA;EACA,oBAAA;MAAA,cAAA;EACA,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,iBAAA;EACA,iBAAA;AAbJ;AAeI;EACE,iBAAA;EACA,sBAAA;EACA,mBAAA;AAbN;AAgBI;EACE,iBAAA;EACA,mBAAA;EACA,cCnES;ADqDf;AAkBE;EACE,WAAA;EACA,WAAA;EACA,yBC1EW;ED2EX,eAAA;AAhBJ;AAmBE;EACE,eAAA;EACA,gBAAA;EAEA,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,cCrFW;ADmEf;AAoBE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,cC9FW;AD4Ef;AAoBE;EACE,cCjGW;EDkGX,iBAAA;EACA,oBAAA;MAAA,cAAA;EACA,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,iBAAA;EACA,iBAAA;AAlBJ;AAoBE;EACE,cCzGW;ED0GX,iBAAA;EACA,oBAAA;MAAA,cAAA;EACA,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,iBAAA;EACA,iBAAA;AAlBJ;AAoBE;EACE,cCjHW;EDkHX,iBAAA;EACA,oBAAA;MAAA,cAAA;EACA,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,iBAAA;EACA,iBAAA;AAlBJ;AAoBE;EACE,cCzHW;ED0HX,iBAAA;EACA,oBAAA;MAAA,cAAA;EACA,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,iBAAA;EACA,eAAA;AAlBJ;AAoBE;EACE,cCjIW;EDkIX,iBAAA;EACA,oBAAA;MAAA,cAAA;EACA,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,iBAAA;EACA,iBAAA;AAlBJ;AAqBE;EACE,cC1IW;ED2IX,iBAAA;EACA,oBAAA;MAAA,cAAA;EACA,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,iBAAA;EACA,iBAAA;AAnBJ;AAqBE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,cCxJW;ADqIf;AAsBE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,cClKW;AD8If;AAuBE;EACE,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,8BAAA;EAAA,6BAAA;MAAA,uBAAA;UAAA,mBAAA;EACA,wBAAA;AArBJ;AAwBE;EACE,qBAAA;EACA,iBAAA;EACA,0BAAA;EAAA,uBAAA;EAAA,kBAAA;EACA,YAAA;EACA,cAAA;EACA,yBCzHK;ED0HL,yBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;AAtBJ;AAwBI;EACE,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,wBAAA;MAAA,qBAAA;UAAA,uBAAA;EACA,yBAAA;MAAA,sBAAA;UAAA,mBAAA;EACA,cC3LS;ED4LT,kBAAA;EACA,iBAAA;AAtBN;AA0BE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;MAAA,cAAA;EACA,QAAA;AAxBJ;AA2BE;EACE,gBAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;AAzBJ;AA4BE;EACE,mBAAA;AA1BJ;AA6BE;EACE,oBAAA;EACA,gCAAA;EACA,mBAAA;AA3BJ;AA6BI;EACE,4BAAA;EAAA,6BAAA;MAAA,0BAAA;UAAA,sBAAA;AA3BN","sourcesContent":["@import '../../../../Global/Colors.scss';\n.SubscriptionFeatureList {\n  &__feature {\n    display: flex;\n    position: relative;\n    margin-bottom: 16px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n    .zervant-icon {\n      position: relative;\n      margin-right: 17px;\n      top: 2px;\n    }\n  }\n\n  &__featureType__invoicing,\n  &__featureType__accounting,\n  &__featureType__admin {\n    &__title {\n      color: $DeepSeaGreen;\n      font-size: 14px;\n      font-weight: bold;\n      margin: 30px 0;\n    }\n    &__text {\n      font-size: 11px;\n      font-weight: 500;\n\n      line-height: 16px;\n      letter-spacing: normal;\n      text-align: left;\n      color: $DeepSeaGreen;\n      display: flex;\n      gap: 5px;\n\n      &__infinity {\n        background: url('./infinity.png') no-repeat center;\n        background-size: 12px;\n        width: 12px;\n        height: 15px;\n      }\n    }\n  }\n\n  &__featureType__invoicing {\n    &__title {\n      margin-top: -5px;\n    }\n  }\n\n  &__amount {\n    color: $DeepSeaGreen;\n    font-weight: bold;\n    flex-shrink: 0;\n    display: flex;\n    margin-left: 27px;\n    margin-top: -12px;\n\n    &.amount_invoice {\n      font-size: 0.9rem;\n      margin-bottom: 0.65rem;\n      padding-top: 0.3rem;\n    }\n\n    &__asterisk {\n      padding-left: 5px;\n      font-weight: normal;\n      color: $DeepSeaGreen;\n    }\n  }\n\n  &__blackMinus {\n    height: 2px;\n    width: 11px;\n    background-color: $DeepSeaGreen;\n    margin-top: 8px;\n  }\n\n  &__text {\n    font-size: 11px;\n    font-weight: 500;\n\n    line-height: 16px;\n    letter-spacing: normal;\n    text-align: left;\n    color: $DeepSeaGreen;\n  }\n  &__text_invoices {\n    font-size: 11px;\n    font-weight: 500;\n    margin-left: 27px;\n    line-height: 16px;\n    letter-spacing: normal;\n    text-align: left;\n    color: $DeepSeaGreen;\n  }\n  &__text_invoices_starter_num {\n    color: $DeepSeaGreen;\n    font-weight: bold;\n    flex-shrink: 0;\n    display: flex;\n    margin-left: 27px;\n    margin-top: -16px;\n  }\n  &__text_invoices_pro_num {\n    color: $DeepSeaGreen;\n    font-weight: bold;\n    flex-shrink: 0;\n    display: flex;\n    margin-left: 27px;\n    margin-top: -16px;\n  }\n  &__text_invoices_pro {\n    color: $DeepSeaGreen;\n    font-weight: bold;\n    flex-shrink: 0;\n    display: flex;\n    margin-left: 28px;\n    margin-top: -16px;\n  }\n  &__text_invoices_pro_dropdown {\n    color: $DeepSeaGreen;\n    font-weight: bold;\n    flex-shrink: 0;\n    display: flex;\n    margin-left: 10px;\n    margin-top: 9px;\n  }\n  &__text_invoices_starter {\n    color: $DeepSeaGreen;\n    font-weight: bold;\n    flex-shrink: 0;\n    display: flex;\n    margin-left: 28px;\n    margin-top: -16px;\n  }\n\n  &__text_invoices_estimates {\n    color: $DeepSeaGreen;\n    font-weight: bold;\n    flex-shrink: 0;\n    display: flex;\n    margin-left: 27px;\n    margin-top: -12px;\n  }\n  &__text_premium_invoice {\n    font-size: 11px;\n    font-weight: 500;\n    margin-left: 27px;\n    line-height: 16px;\n    letter-spacing: normal;\n    text-align: left;\n    color: $DeepSeaGreen;\n  }\n\n  &__text_premium_customers {\n    font-size: 11px;\n    font-weight: 500;\n    margin-left: 27px;\n    line-height: 16px;\n    letter-spacing: normal;\n    text-align: left;\n    color: $DeepSeaGreen;\n  }\n\n  &__invoice-quota-multiple-plan_wrapper {\n    display: flex;\n    flex-direction: row;\n    margin: -0.6rem 0 0.5rem;\n  }\n\n  &__invoice-quota-multiple-plan {\n    display: inline-block;\n    font-size: 1.2rem;\n    width: fit-content;\n    height: 32px;\n    padding: 0 9px;\n    background-color: $Gray20;\n    border: 1px solid $Gray30;\n    line-height: 32px;\n    font-size: 0.9rem;\n    font-weight: bold;\n\n    &__asterisk {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      color: $DeepSeaGreen;\n      padding-left: 10px;\n      font-size: 0.9rem;\n    }\n  }\n\n  &__checkmark {\n    position: relative;\n    width: 11px;\n    height: 11px;\n    margin-right: 19px;\n    flex-shrink: 0;\n    top: 2px;\n  }\n\n  &__line {\n    margin-top: 16px;\n    height: 1px;\n    background-color: lighten($color: $Gray30, $amount: 4);\n    margin-bottom: 16px;\n  }\n\n  &__spacing {\n    margin-bottom: 16px;\n  }\n\n  &--highlighted-items {\n    padding-bottom: 15px;\n    border-bottom: 1px solid $Gray20;\n    margin-bottom: 15px;\n\n    .SubscriptionFeatureList__feature {\n      flex-direction: column;\n    }\n  }\n}\n","// Brand\n$ElectricGreen: #01FF94;\n$DeepSeaGreen: #002E33;\n$Lavender: #DBD4FF;\n$DayGrey: #EDF1F7;\n\n// Primary\n$Black: #000;\n$White: #FFF;\n$Green: #00E383;\n$Yellow: #FBDB3F;\n$Red: #D92D20;\n$Purple: #5E46D2;\n\n// Blues\n$Blue140: #131C3E;\n$Blue120: #1E267D;\n$Blue110: #2258CE;\n$Blue90: #5E8BEF;\n$Blue60: #7CA2F8;\n$Blue10: #D0E6FE;\n$Blue5: #E4F1FF;\n\n// Purples\n$Purple140: #5D4DAE;\n$Purple20: #F8F6FF;\n\n// Greens\n$Green140: #075E42;\n$Green120: #078E64;\n$Green110: #29B574;\n$Green90: #32D583;\n$Green60: #6CE9A6;\n$Green20: #BAEFCB;\n$Green10: #DDF3E4;\n$Green5: #E8FFF0;\n\n// Yellows\n$Yellow220: #735714;\n$Yellow200: #8F7638;\n$Yellow120: #DCB11A;\n$Yellow30: #FFF8B8;\n$Yellow10: #FFF9CC;\n\n// Reds\n$Red120: #951307;\n$Red110: #C94337;\n$Red90: #F07B70;\n$Red10: #F7DDD9;\n$Red5: #FFF8F6;\n\n// Grays\n$Gray200: #26282F;\n$Gray90: #697588;\n$Gray60: #A7A9B4;\n$Gray50: #D3D6DF;\n$Gray40: #D9DCE5;\n$Gray30: #E8E9F0;\n$Gray20: #F5F6F9;\n$Gray10: #F6F9FF;\n\n// Legacy color variables: Remove these after deprecating @zervant/reactcomponents package\n$shadowColor: #5F6766;\n$normalTextColor: $Gray200;\n$normalBorderColor: $Gray30;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
